module.exports = __webpack_public_path__ + "img/Cloud.b357d6f8.png";